/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DialogFlowTemplateMessageOption = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The DialogFlowTemplateMessageOption model module.
   * @module model/DialogFlowTemplateMessageOption
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DialogFlowTemplateMessageOption</code>.
   * @alias module:model/DialogFlowTemplateMessageOption
   * @class
   */
  var exports = function() {
    var _this = this;









  };

  /**
   * Constructs a <code>DialogFlowTemplateMessageOption</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DialogFlowTemplateMessageOption} obj Optional instance to populate.
   * @return {module:model/DialogFlowTemplateMessageOption} The populated <code>DialogFlowTemplateMessageOption</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('FlowTemplateID')) {
        obj['FlowTemplateID'] = ApiClient.convertToType(data['FlowTemplateID'], 'Integer');
      }
      if (data.hasOwnProperty('OptionText')) {
        obj['OptionText'] = ApiClient.convertToType(data['OptionText'], 'String');
      }
      if (data.hasOwnProperty('NextMessageID')) {
        obj['NextMessageID'] = ApiClient.convertToType(data['NextMessageID'], 'Integer');
      }
      if (data.hasOwnProperty('FromMessageID')) {
        obj['FromMessageID'] = ApiClient.convertToType(data['FromMessageID'], 'Integer');
      }
      if (data.hasOwnProperty('IsExitOption')) {
        obj['IsExitOption'] = ApiClient.convertToType(data['IsExitOption'], 'Boolean');
      }
      if (data.hasOwnProperty('LogicGateMatchRuleID')) {
        obj['LogicGateMatchRuleID'] = ApiClient.convertToType(data['LogicGateMatchRuleID'], 'Integer');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} FlowTemplateID
   * @default 0
   */
  exports.prototype['FlowTemplateID'] = 0;
  /**
   * @member {String} OptionText
   * @default ''
   */
  exports.prototype['OptionText'] = '';
  /**
   * @member {Integer} NextMessageID
   */
  exports.prototype['NextMessageID'] = undefined;
  /**
   * @member {Integer} FromMessageID
   * @default 0
   */
  exports.prototype['FromMessageID'] = 0;
  /**
   * @member {Boolean} IsExitOption
   * @default false
   */
  exports.prototype['IsExitOption'] = false;
  /**
   * @member {Integer} LogicGateMatchRuleID
   */
  exports.prototype['LogicGateMatchRuleID'] = undefined;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


